import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import "./style.css"

const navLinks = [
  { label: "HOME",     to: "/" },
  { label: "SKILLS",   to: "/skills" },
  { label: "PROJECTS", to: "/projects" },
  { label: "SERVICES", to: "/services" },
  { label: "BLOGS",    to: "/blogs" },
]

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false)

  const closeMenu = () => setMenuOpen(false)
  const toggleMenu = () => setMenuOpen(prev => !prev)

  return (
    <div className="headWrapper z-[1] md:pt-24">
      <div className="header h-full">

        <NavLink to="/">
          <div className="flex justify-center items-center">
            <div className="text-[37px] md:text-[45px] headingFont">NS.</div>
          </div>
        </NavLink>

        <div className={menuOpen ? "menuActive menu" : "menu"}>
          <ul className="textFont">
            {navLinks.map(({ label, to }) => (
              <li key={to} className="m-[30px] md:m-[15px]" onClick={closeMenu}>
                <NavLink
                  to={to}
                  end={to === "/"}
                  className={({ isActive }) => isActive ? "active_item" : "menu_item"}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        <div onClick={toggleMenu} className={menuOpen ? "navToggler toggle" : "navToggler"}>
          <div className="line1"></div>
          <div className="line2"></div>
          <div className="line3"></div>
        </div>

      </div>
    </div>
  )
}